import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import {
  allPlatforms,
  allUnitPriceTypes,
  Channel,
  Platform,
  UnitPriceType
} from 'shared/src/domain/line-item/line-item-channels';

type ContextValue = {
  channels: Channel[];
  platforms: Platform[];
  unitPriceTypes: UnitPriceType[];
  cpm: UnitPriceType;
};

const ChannelRatesContext = createContext<ContextValue | null>(null);

type Props = {
  channels: Channel[];
  children: ReactNode;
};

export function ChannelRatesContextProvider({ channels, children }: Props) {
  const value = useMemo(() => {
    const unitPriceTypes = allUnitPriceTypes(channels);
    const cpm = unitPriceTypes.find(u => u.id === 1);
    if (!cpm) {
      throw new Error('CPM unit price type not found');
    }
    const platforms = allPlatforms(channels);
    return {
      channels,
      platforms,
      unitPriceTypes,
      cpm
    };
  }, [channels]);
  return <ChannelRatesContext value={value}>{children}</ChannelRatesContext>;
}

export function useChannelRatesContext() {
  const value = useContext(ChannelRatesContext);
  if (!value) {
    throw new Error('useChannelRatesContext must be used within a ChannelRatesContextProvider');
  }
  return value;
}
